import React from 'react';
import {
  CardMedia,
  Card,
  Button,
  CardActions,
  CardTitle
} from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import { useImpression } from '@thd-olt-component-react/impression';
import ListsHeader from '../ListsHeader';
import { nullStatePropTypes } from './nullStatePropTypes';
import { defaultCardContentProps } from '../../../constants/responsiveClassNames';
import LearnMore from '../LearnMore';

const DesktopNullView = ({
  cardTitle,
  cardBody,
  imageUrl,
  imageAlt,
  cta,
  componentId
}) => {

  const { ref, clickID } = useImpression({
    data: {
      component: 'Lists',
      name: 'ListsNullState',
      id: componentId,
      position: 1,
      type: 'content',
    }
  });

  return (
    <Card
      data-component="Lists"
      data-testid="lists"
      orientation="horizontal"
      className="sui-h-full"
      CardContentProps={{
        className: classNames(
          defaultCardContentProps,
          'sui-h-full',
          'sui-w-full'
        )
      }}
    >
      {/* eslint-disable-next-line react/no-unknown-property */}
      <div className="sui-flex sui-gap-4 sui-h-full" ref={ref} clickid={clickID}>
        <div className=" sui-flex sui-flex-col sui-gap-4 sui-h-full sui-min-w-max">
          <div className="sui-mb-4">
            <ListsHeader hideActions />
          </div>
          <CardTitle
            headerVariant="h3"
            headerWeight="display"
            header={cardTitle}
          />
          {cardBody}
          <CardActions>
            <div className="sui-flex sui-gap-4 sui-text-nowrap">
              <Button fullWidth variant="secondary" href="/c/create-a-list">Learn More</Button>
              <LearnMore variant="button" />
            </div>
          </CardActions>
        </div>
        <div>
          <CardMedia
            src={imageUrl}
            alt={imageAlt}
            className={`sui-w-full sui-h-full sui-transform
                 sui-object-cover sui-object-center`}
          />
        </div>
      </div>
    </Card>
  );
};

DesktopNullView.propTypes = nullStatePropTypes;

export default DesktopNullView;
